import { render } from "./CoursesHomePage.vue?vue&type=template&id=379ad1c3"
import script from "./CoursesHomePage.vue?vue&type=script&lang=js"
export * from "./CoursesHomePage.vue?vue&type=script&lang=js"

import "./CoursesHomePage.vue?vue&type=style&index=0&id=379ad1c3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__